import { Router } from '@angular/router';
import { Component, OnInit, ViewChild } from '@angular/core';
import { environment } from 'environments/environment';
import { Globals } from './../../../_globals';
import { TrainingService } from 'app/_services/training.service';
import { SortEvent } from 'primeng/api';
import { TrainingCourse } from 'app/_models/training/training-course.model';
import { NotificationService } from 'app/_services/notification.service';

@Component({
  selector: 'manage-trainings',
  templateUrl: './manage-trainings.component.html',
})
export class ManageTrainingsComponent implements OnInit {
  public training: TrainingCourse[];
  public selectedTraining: any[];

  public filterText = '';
  public isFilterLoading: boolean;
  public pageSizes: any = environment.pageSizes;
  public pagination: any;

  public role: any;
  public routeRole: any;
  public isSiteOwner = false;
  public isPowerStationOwner = false;
  public createButtonAction = 'CREATE NEW TRAINING';

  @ViewChild('paginator', { static: true }) paginator;

  // Sorting List
  public defaultSortField = 'name';
  public defaultSortOrder = 1;
  private sortOrderToText = (sortOrder: number) => {
    return sortOrder === 1 ? 'asc' : 'desc';
  };
  public selectedSort = [this.defaultSortField + ',' + this.sortOrderToText(this.defaultSortOrder)];

  constructor(public router: Router,
    public globals: Globals,
    private trainingService: TrainingService,
    private notificationService: NotificationService) {
    this.routeRole = globals.user.routeRole;
    this.isSiteOwner = this.routeRole === 'site-owner' || this.routeRole === 'power-station-owner';
    if (this.routeRole === 'power-station-owner') {
      this.createButtonAction = 'CREATE NEW TRAINING/ACCEPTANCE';
    }
  }

  ngOnInit() {
    this.resetPagination();
  }

  // Create Inductions/Training
  public createNewTraining() {
    this.router.navigate(['/' + this.routeRole + '/training/create']);
  }

  // Filter
  public onFilterTextChangedName(filterText: string) {
    this.isFilterLoading = true;
    this.filterText = filterText;

    this.goToFirstPage();
    this.listAllInductionsTrainings();
  }

  // Table
  public listAllInductionsTrainings() {
    this.trainingService.getAllTrainingCourses(this.pagination, this.selectedSort, this.filterText).subscribe(
      (response) => {
        this.isFilterLoading = false;
        this.training = response.body;
        this.pagination.totalRecords = response.totalRecords;
      },
      (error) => {
        console.error(error);
        this.notificationService.notify('danger', 'Error retrieving inductions/training list');
        this.isFilterLoading = false;
      }
    );
  }

  onRowSelect(course: TrainingCourse) {
    this.router.navigate(['/' + this.routeRole + '/training/' + course.trainingId]);
  }

  // Pagination
  public paginate(event) {
    this.pagination.size = event.rows;
    this.pagination.page = event.page;
    this.listAllInductionsTrainings();
  }

  public resetPagination() {
    this.pagination = {
      size: this.pageSizes[0],
      page: 0,
      totalRecords: 0,
    };

    this.goToFirstPage();

    this.listAllInductionsTrainings();
  }

  public customSort(sort: SortEvent) {
    const sortDirection = this.sortOrderToText(sort.order);

    this.selectedSort = [sort.field + ',' + sortDirection];

    this.goToFirstPage();

    this.listAllInductionsTrainings();
  }

  private goToFirstPage() {
    this.pagination.page = 0;      // Backend: reset page index to fetch from API
    if (this.paginator) {
      this.paginator.first = 0;    // Frontend: update visual page indicator (PrimeNg)
    }
  }
}
